let redirect = [
  {
    path: '/redirect/promotion',
    name: '活动详情',
    component: () => import('@/pages/redirect/promotion.vue')
  },
  {
    path: '/redirect/promotion_mp',
    name: '活动详情',
    component: () => import('@/pages/redirect/promotion_mp.vue')
  },
  {
    path: '/tencent_guide',
    name: '活动详情',
    component: () => import('@/pages/redirect/tencent_guide.vue')
  }
  ,
  {
    path: '/direct_redirect',
    name: '跳转',
    component: () => import('@/pages/redirect/redirect.vue')
  },
  {
    path: '/redirect/activity_link_transfer',
    name: '活动中转页',
    component: () => import('@/pages/redirect/activity_link_transfer.vue')
  }
]

export default redirect
